import './assets/main.css'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'

import { createApp } from 'vue'
import { createHead } from '@unhead/vue/client'
import VueVirtualScroller from 'vue-virtual-scroller'

import App from './App.vue'
import router from './router'

import * as Sentry from '@sentry/vue'

const app = createApp(App)
const head = createHead()

Sentry.init({
  app,
  dsn: 'https://1683e5429a9d7ed3dccf0790e311607c@o4509345569243136.ingest.de.sentry.io/4509351693189200',
  integrations: [
    Sentry.replayIntegration(),
    Sentry.browserTracingIntegration(),
  ],
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 1.0,
  tracesSampleRate: 0.2,
  tracePropagationTargets: [/https:\/\/stichtingnoordmans\.nl.*/],
})

app.use(VueVirtualScroller)

app.use(router)
app.use(head)

app.mount('#app')
